import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

export interface SerializableUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  emailVerified: boolean;
}

interface UserState {
  user: SerializableUser | null;
  userData: Users.User | null;
  authReady: boolean;
  hasOffer: boolean;
  partnerInviteCount: number;
}

const initialState: UserState = {
  user: null,
  userData: null,
  authReady: false,
  hasOffer: false,
  partnerInviteCount: 0,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<SerializableUser | null>) {
      state.user = action.payload;
    },
    setUserData(state, action: PayloadAction<Users.User | null>) {
      state.userData = action.payload;
    },
    setAuthReady(state, action: PayloadAction<boolean>) {
      state.authReady = action.payload;
    },
    setHasOffer(state, action: PayloadAction<boolean>) {
      state.hasOffer = action.payload;
    },
    setPartnerInviteCount(state, action: PayloadAction<number>) {
      state.partnerInviteCount = action.payload;
    },
    clearUser(state) {
      state.user = null;
      state.userData = null;
      state.hasOffer = false;
      state.partnerInviteCount = 0;
    },
  },
});

export const { setUser, setUserData, setAuthReady, setHasOffer, setPartnerInviteCount, clearUser } =
  userSlice.actions;

export const selectUser = (state: RootState) => state.user.user;
export const selectUserData = (state: RootState) => state.user.userData;
export const selectAuthReady = (state: RootState) => state.user.authReady;
export const selectHasOffer = (state: RootState) => state.user.hasOffer;
export const selectPartnerInviteCount = (state: RootState) => state.user.partnerInviteCount;
export const selectHasPartnerInvite = (state: RootState) => state.user.partnerInviteCount > 0;

export default userSlice.reducer;
